import { render, staticRenderFns } from "./details.vue?vue&type=template&id=01078596&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=01078596&prod&scoped=true&lang=css"
import style1 from "./details.vue?vue&type=style&index=1&id=01078596&prod&lang=scss"
import style2 from "./details.vue?vue&type=style&index=2&id=01078596&prod&scoped=true&lang=css"
import style3 from "./details.vue?vue&type=style&index=3&id=01078596&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01078596",
  null
  
)

export default component.exports